const PT_LOGO = '/pt-logo.png';

export const PtMark = ({ size = 42, boxed = false }) => {
    const img = (
        <img
            src={PT_LOGO}
            alt="Logo Pt de #PICHONTEAM"
            style={{ width: size, height: 'auto' }}
            data-testid="pt-logo-image"
        />
    );
    if (!boxed) return img;
    return (
        <span
            className="inline-flex items-center justify-center rounded-2xl bg-pastelcream shadow-lg shrink-0"
            style={{ width: size * 1.5, height: size * 1.5 }}
            data-testid="pt-logo-boxed"
        >
            {img}
        </span>
    );
};

export const Wordmark = ({ dark = false, compact = false }) => (
    <div className="flex items-center gap-3" data-testid="brand-wordmark">
        <PtMark size={compact ? 30 : 38} boxed={dark} />
        <div className="leading-none text-left">
            <div
                className={`font-wordmark font-semibold tracking-[0.08em] ${compact ? 'text-base' : 'text-lg'} ${dark ? 'text-pastelcream' : 'text-ink'}`}
            >
                #PICHONTEAM
            </div>
            <div
                className={`font-wordmark tracking-[0.3em] ${compact ? 'text-[9px]' : 'text-[10px]'} mt-1 text-crimson`}
            >
                GROWTH&nbsp;PARTNERS
            </div>
        </div>
    </div>
);
